import React, { Component } from 'react';
import './css/Actividad.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import { Solicitud_materia } from './expand/Solicitud_materia';
import { Nueva_actividad } from './modal/Nueva_actividad';
import { Resumen_Observaciones } from './tablas/Resumen_Observaciones';
import { Tabla_Actividades } from './tablas/Tabla_Actividades';
import 'bootstrap/dist/css/bootstrap.min.css';
//import { Col, Row, Container } from 'react-bootstrap';
//import crear from './../img/svg/Nueva.svg';
//import enviar from './../img/svg/Enviar(blanco).svg';
import Swal from 'sweetalert2'


const API_URL = process.env.REACT_APP_API_URL;

//Funcion para colocar color a las headers la tabla
function color_head() {
    return {
        backgroundColor: '#25223f',
        color: 'white',
        width: '15%', fontSize: 11,
    };
}

function color_head_desc(tipo) {
    if (tipo === 'a') {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '50%'
        };
    } else if (tipo === 'd') {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '30%'
        }
    } else if (tipo === 'id') {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '10%'
        };
    } else {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '30%'
        };
    }
}
//Funcion para colocar color a las celdasde la tabla
function color(rowIndex) {
    if (rowIndex % 2 === 0) {
        return {
            backgroundColor: 'white'
        };
    }
    return {
        backgroundColor: '#E7E7E7'
    };
}
 
function PaoFormatter(termino,anio) {
    switch (termino) {
        case "1ER TERMINO":
            return (
                <>PAO-{anio}-1</>
            );
            break;
        case "2DO TERMINO":
            return (
                <>PAO-{anio}-2</>
            );
            break;
        case "3ER TERMINO":
            return (
                <>PAE-{anio}</>
            );
            break;

        case "1S":
            return (
                <>PAO-{anio}-1</>
            );
            break;
        case "2S":
            return (
                <>PAO-{anio}-2</>
            );
            break;
        case "3S":
            return (
                <>PAE-{anio}</>
            );
            break;
        default:
            return (
                <>{termino}</>
            );
            break;
    }
}

export class Docencia_Grado extends Component {
    static displayName = Docencia_Grado.name;
    static totalmat = 0;
    static totalact = 0;


    handleBtnClick_mat = () => {
        if (!this.state.expanded_mat.includes(0)) {
            this.setState(() => ({
                expanded_mat: [...this.state.expanded_mat, 0]
            }));
        } else {
            this.setState(() => ({
                expanded_mat: this.state.expanded_mat.filter(x => x !== 0)
            }));

        }
    }

    handleOnExpand_mat = (row, isExpand, rowIndex, e) => {
        if (isExpand) {
            this.setState(() => ({
                expanded_mat: [...this.state.expanded_mat, row.id]
            }));
        } else {
            this.setState(() => ({
                expanded_mat: this.state.expanded_mat.filter(x => x !== row.id)
            }));
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            actividades: [], solicitudes: [], busqueda: "", actividad: {
                idactividad: 0, actividad: "", tipoactividad: 0, descripcion: "", idtipoactividad: "", numhoras: 0,
                anio: "", termino1: "", termino2: "", termino3: "", periodicidad: "", totalhoras: 0, estadocheck: "", escarga: ""
            },
            fila: [],
            fila_mat: [],
            actividad_elegida: [
                { idactividad: 0, validada: "", estado_actividad: "" }
            ], materias: [], materia: {
                idcurso: 0, porc: 0, anio: "", term: "", termino: "", codigomateria: "", nommateria: "", numhorasteoricas: 0, numhoraspracticas: 0, paralelo: 0, idtipoactividad: 0,
                observacion: "", fechaInicio: "", fechaFin: "", valorevaluacion: 0, valornumexam: 0, estadocheck: "", tipoprofesor: ""
            }, loading: false, loading2: false, loading3: false, expanded: [], expanded_mat: [], total: 0,
            materia_elegida: [{ idcurso: 0, validada: "", estado_actividad: "" }],
            anio: props.anio, terminoPeriodo: props.terminoPeriodo, idpersona: props.idprof, actividades_combo: [], periodo: "", newactividad: "", observacion: "",
            nuevoregistro: [], selectact: "", selectidact: "", abierto: false, valida_next: false, solicitudes_act:[]
        };

         
        this.setconteo_final = this.setconteo_final.bind(this);
        this.setfila = this.setfila.bind(this);
        this.updatestate = this.updatestate.bind(this);
        this.updatestate_mat = this.updatestate_mat.bind(this); 
        this.isValidated_all = this.isValidated_all.bind(this);
        this.closeExpandxId = this.closeExpandxId.bind(this);
        this.closeExpandxId_mat = this.closeExpandxId_mat.bind(this);
    }


    componentDidMount() {
        let solicitudes = this.props.getSolicitudes('');
        //console.log("solicitudes_act: ", solicitudes);
        if (solicitudes) {
            this.setState({
                solicitudes_act: solicitudes
            })
        }

        if (this.state.anio > 0) {
            this.populateActividadesData(this.props.idprof, this.props.anio);
            this.populateMateriasData(this.props.idprof, this.props.anio);
            this.populateActividadesCombo(this.props.idprof, this.props.anio);
        }
    }


    get_radios(termino1, termino2, termino3, anio) {
        //var respu;
        if (termino2 === "2" && termino1 === "1" && termino3 === "0") {
            return (
                'PAE-' + anio + '\n  PAO-' + anio + '-1\n PAO-' + anio + '-2'
            )
        }
        else if (termino1 === "1") {
            if (termino1 === "1" && termino3 === "0") {
                return (
                    'PAO-' + anio + '-1 \nPAE-' + anio
                );
            } else if (termino2 === "2" && termino1 === "1") {
                return (
                    'PAO-' + anio + '-1 \nPAO-' + anio + '-2'
                );

            } else {
                return (
                    'PAO-' + anio + '-1'
                );
            }
        } else if (termino2 === "2") {
            if (termino2 === "2" && termino1 === "1") {
                return (
                    'PAO-' + anio + '-1\n PAO-' + anio + '-2'
                );

            } else if (termino2 === "2" && termino3 === "0") {
                return (
                    'PAO-' + anio + '-2\n PAE-' + anio
                );
            }
            return (
                'PAO-' + anio + '-2'
            );
        } else if (termino3 === "0") {
            if (termino3 === "0" && termino1 === "1") {
                return (
                    'PAE-' + anio + '\n PAO-' + anio + '-1'
                );

            } else if (termino3 === "0" && termino2 === "2") {
                return (
                    'PAE-' + anio + '\n PAO-' + anio + '-2'
                );
            }
            return (
                'PAE-' + anio
            );
        }
    }
    updatestate(rowIndex,idactividad, descripcion, totalhoras, anio, termino, tipoactividad, observacion, pao1, pao2, pae, accion, idUnico) {
        //const terminos = this.get_radios(pao1, pao2, pae, anio)
        var solicitudes = this.state.solicitudes 
       
        if (solicitudes.length === 0) {
            solicitudes = []
        } else {
            solicitudes = this.state.solicitudes.filter(x => x.idactividad !== idactividad)
        }
        //console.log('VER DESDE NUEVO EL TERMINO:' + termino)
        solicitudes.push({ idactividad: idactividad, observacion: observacion, descripcion: descripcion, totalhoras: totalhoras, anio: anio, termino: termino, tipoactividad: tipoactividad, pao1: pao1, pao2: pao2, pae: pae, accion: accion, idUnico: idUnico })
       
        this.setState({ solicitudes: solicitudes });
        //console.log(this.state.solicitudes)
        this.props.update({ ambito: 'A|R', idactividad: idactividad, observacion: observacion, descripcion: descripcion, totalhoras: totalhoras, anio: anio, termino: termino, tipoactividad: 'A|R', pao1: pao1, pao2: pao2, pae: pae, accion: accion, idUnico: idUnico });

    }

    updatestate_mat(rowIndex,idcurso, descripcion, observacion, anio, termino, totalhoras, accion, idUnico) {
        var solicitudes = this.state.solicitudes
         

        if (solicitudes.length === 0) {
            solicitudes = []
        } else {
            solicitudes = this.state.solicitudes.filter(x => x.idactividad !== idcurso)
        }

        solicitudes.push({
            idactividad: idcurso, descripcion: descripcion, observacion: observacion, anio: anio, pao1: termino, pao2: termino, pae: termino, totalhoras: totalhoras, termino: termino, accion: accion
        })
        this.setState({ solicitudes: solicitudes }, () => {
            //console.log("solicitudes: ", this.state.solicitudes);
        });

        this.props.update({ ambito: 'M|R', idactividad: idcurso, descripcion: descripcion, observacion: observacion, anio: anio, pao1: termino, pao2: termino, pae: termino, tipoactividad: 'M|R', totalhoras: totalhoras, termino: termino, accion: accion, idUnico: idUnico });

    }

    closeExpandxId(idactividad) {
        if (this.state.expanded.includes(idactividad)) {
            this.setState(() => ({
                expanded: this.state.expanded.filter(x => x !== idactividad)
            }));
        }
    }

    closeExpandxId_mat(idcurso) {
        //console.log('DENTRO DE EXPALNDID');

        //console.log("solicitudes_act: ", this.state.solicitudes_act);
        if (this.state.expanded_mat.includes(idcurso)) {
            this.setState(() => ({
                expanded_mat: this.state.expanded_mat.filter(x => x !== idcurso)
            }));
        }
    }
    /////FUNCIONES para interactuar con los si/no de Materias
    handleHideClick_mat = (idactividad) => {
        //console.log("handleHideClick_mat: ", idactividad);
        const check = document.getElementsByName("all_mg");
        check[0].checked = false;
        check[1].checked = false;

        let obj = this.state.fila_mat.find((o, i) => {
            if (o.idactividad === idactividad) {
                if (this.state.fila_mat[i].validacion === 'no') {
                    this.state.fila_mat[i].validacion = 'si'
                    //console.log("this.state.fila_mat[i]: ", this.state.fila_mat[i]);
                    return this.state.fila_mat[i];
                }
            }
        });
        if (obj == null) {
            this.state.fila_mat.push({
                idactividad: idactividad,
                validacion: 'si'
            })
        } else {
            this.mensaje_afirma(idactividad)
        }
        this.props.setconteo_final_mat(this.state.fila_mat,'R');
    }

    handleShowClick_mat = (idactividad) => {
        const check = document.getElementsByName("all_mg");
        check[0].checked = false;
        check[1].checked = false;

        //console.log('MATERIA:' + idactividad)
        if (!this.state.expanded_mat.includes(idactividad)) {

            let obj = this.state.fila_mat.find((o, i) => {
                if (o.idactividad === idactividad) {
                    this.state.fila_mat[i].validacion = 'no'
                    return this.state.fila_mat[i];
                }
            });
            if (obj == null) {
                this.state.fila_mat.push({
                    idactividad: idactividad,
                    validacion: 'no'
                })
            }
            this.setState(() => ({
                expanded_mat: [...this.state.expanded_mat, idactividad]
            }));
        }
        this.props.setconteo_final_mat(this.state.fila_mat, 'R');
    }

    handleHideAllClick_mat = () => {

        let filas = [];

        this.state.materias.forEach((element) => {
            filas.push({
                idactividad: element.idCurso,
                validacion: 'si'
            });
        })
        this.setState(() => ({
            expanded_mat: [],
            fila_mat: filas
        })); 
        this.props.setconteo_final_mat(filas, 'R');
        this.handleAllCheck_mat()
    }

    handleShowAllClick_mat = () => {
        let filas = [];
        let expandir = [];

        if (this.props.terminoPeriodo === "2S") {
            this.state.materias.forEach((element) => {
                if (element.term === "2S") {
                    filas.push({
                        idactividad: element.idCurso,
                        validacion: 'no'
                    });
                    if (!this.state.expanded_mat.includes(element.idCurso)) {
                        expandir.push(element.idCurso);
                    }
                } else {
                    filas.push({
                        idactividad: element.idCurso,
                        validacion: 'si'
                    });
                }
            });

        } else {
            this.state.materias.forEach((element) => {
                filas.push({
                    idactividad: element.idCurso,
                    validacion: 'no'
                });
                if (!this.state.expanded_mat.includes(element.idCurso)) {
                    expandir.push(element.idCurso);
                }
            });
        }

        this.setState(() => ({
            expanded_mat: this.state.expanded_mat.concat(expandir),
            fila_mat: filas
        }));
        this.props.setconteo_final_mat(filas, 'R');
        this.handleAllCheck_mat()
    }

    handleAllCheck_mat() { 
        const check = document.getElementsByName("all_mg");
        const checkSin = document.getElementById("Materias_mg").getElementsByClassName('form-check-input'); 
        if (check[0].checked) {
            //console.log('MATERIA:' + 'Siu');
            for (let i = 0; i < checkSin.length; i++) {
                if (this.props.terminoPeriodo === "2S") {
                    if (checkSin[i].value === "1" && !checkSin[i].disabled) {
                        checkSin[i].checked = true;
                    }
                    //else {
                    //    checkSin[i].checked = false;
                    //}
                } else {
                    if (checkSin[i].value === "1") {
                        checkSin[i].checked = true;
                    } else {
                        checkSin[i].checked = false;
                    }
                }
            }
            let chec = checkSin.length - 1
            //console.log('MATERIA:' + chec);
            //if (!this.state.valida_next) {
            //    this.isValidated_all(chec, this.state.fila.length);
            //}
        } else {
            //console.log('NO A TODO CKICKK EN MATERIAS');
            for (let i = 0; i < checkSin.length; i++) {
                if (this.props.terminoPeriodo === "2S") {
                    if (checkSin[i].value === "0" && !checkSin[i].disabled) {
                        checkSin[i].checked = true;
                    }
                    // else {
                    //    checkSin[i].checked = false;
                    //}
                } else {
                    if (checkSin[i].value === "0") {
                        checkSin[i].checked = true;
                    } else {
                        checkSin[i].checked = false;
                    }
                }  
            }
            let chec = checkSin.length - 1
            //console.log('MATERIA:' + chec);

            //if (!this.state.valida_next) {
            //    this.isValidated_all(chec, this.state.fila.length);
            //}
        }

    }


    mensaje_afirma(idcurso) {

        Swal.fire({
            title: '¿Está seguro de cambiar?',
            text: "Usted podría perder la selección y los datos ingresados de esta observación",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, cambiar selección.',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                if (this.state.expanded_mat.includes(idcurso)) {
                    this.setState(() => ({
                        expanded_mat: this.state.expanded_mat.filter(x => x !== idcurso)
                    }));
                }

                this.props.setSolicitudes(0, idcurso)

                //this.actualizarSolicitudes()

                //Swal.fire({
                //    icon: 'success',
                //    text: 'Tu solicitud de Asignatura/Actividad ha sido eliminada',
                //    title: 'Eliminado',
                //    showConfirmButton: false,
                //    timer: 1500
                //})
            } else {

                let obj = this.state.fila_mat.find((o, i) => {
                    if (o.idactividad === idcurso) {
                        this.state.fila_mat[i].validacion = 'no'
                        return this.state.fila_mat[i];
                    }
                });
                const checksi = document.getElementById("ch1_" + idcurso);
                const checkno = document.getElementById("ch2_" + idcurso);
                //console.log('NO de mensaje afirma')
                checksi.checked = false;
                checkno.checked = true;
            }
        })
    }

    renderMateriasTable(materias) {

        const columns_materias = [{
            dataField: 'id',
            text: '#',

            headerStyle: color_head_desc('id'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            footer: '',
            formatter: (cellContent, row, rowIndex) => {
                return (
                    <div>
                        {rowIndex + 1}
                    </div>
                )
            }
        }, {
            dataField: 'codigoMateria',
            text: 'Código',
            headerStyle: color_head_desc('id'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            footer: ''
        }, {
            dataField: 'nomMateria',
            text: 'Asignatura',
            headerStyle: color_head_desc('a'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            footer: ''
        },
        {
            dataField: 'paralelo',
            text: 'Paralelo',
            headerStyle: color_head_desc('id'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            footer: ''
        },
        {
            dataField: 'termino',
            text: 'Periodo',
            headerStyle: color_head(),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            formatter: (cell, row, rowIndex, colIndex) => {
                return PaoFormatter(row.termino,row.anio)
            },
            footer: 'Subtotal:'
        }, {
            dataField: 'totalHoras',
            text: 'Horas',
            headerStyle: color_head(),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            footerAlign: 'left',
            footer: columnData2 => {
                const total1 = columnData2.reduce((acc2, item2) => (Number(acc2) + Number(item2)).toFixed(2), 0);
                return (<> {total1.toLocaleString('en', { maximumFractionDigits: 2 })} horas</>);
            },
        },
        {
            dataField: 'conformidad',
            text: 'Validada',
            isDummyField: true,
            headerFormatter: (column, colIndex) => {
                return (
                    <div className="text-validada-center">
                        Validar<br />Seleccionar todo<label className="asterisco">*</label>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" name="all_mg" value="1" type="radio" onChange={this.handleHideAllClick_mat} />Si&nbsp;
                            <input className="form-check-input" name="all_mg" value="0" type="radio" onChange={this.handleShowAllClick_mat} />No

                         </div>
                    </div>

                )
            },
            formatter: (cellContent, row, rowIndex) => {
                return (
                    <div>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" id={"ch1_" + row.idCurso} name={'MG' + rowIndex} value="1" type="radio" onChange={() => this.handleHideClick_mat(row.idCurso)} disabled={this.state.terminoPeriodo === "2S" && row.term.trim() !== "2S"} />Si&nbsp;
                            <input className="form-check-input" id={"ch2_" + row.idCurso} name={'MG' + rowIndex} value="0" type="radio" onChange={() => this.handleShowClick_mat(row.idCurso)} disabled={this.state.terminoPeriodo === "2S" && row.term.trim() !== "2S"} />No
                         </div>
                    </div>
                );

                // BLOQUEAR PAE en PAO1: disabled={(this.state.terminoPeriodo === "1S" && row.term.trim() === "0S") || (this.state.terminoPeriodo === "2S" && row.term.trim() !== "2S")}
                //disabled={(row.term.trim() === "0S" && this.state.terminoPeriodo !== "1S") || row.term.trim() !== this.state.terminoPeriodo}
            },
            headerStyle: color_head(),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            }
        }];

        const expandRow2 = {
            onlyOneExpanding: true,
            expanded: this.state.expanded_mat,
            expandByColumnOnly: true,
            renderer: (row, rowIndex) => (
                <div>
                    <Solicitud_materia rowIndex={rowIndex} idcurso={row.idCurso} descripcion={row.nomMateria} paralelo={row.paralelo} observacion={row.observacion} anio={row.anio} termino={row.termino} totalhoras={row.totalHoras} idUnico={row.idUnico} updatestate={this.updatestate_mat} handleHideClick={this.handleHideClick_mat} closeExpandxId={this.closeExpandxId_mat} />

                </div>
            )
        };

        return (
            <BootstrapTable
                id='Materias_mg'
                keyField='idCurso'
                data={materias}
                columns={columns_materias}
                bordered={false}
                expandRow={expandRow2}
            />
        );

    }

    formatter = (valor) => {
        return new Intl.NumberFormat('en-US', { maximumFractionDigits: '2', minimumFractionDigits: '2', signDisplay: 'never' }).format(valor)
    }

    dateFormatter = (strFecha) => {
        var options = { year: 'numeric', month: '2-digit', day: 'numeric' };
        var dtFecha = new Date(strFecha);
        return dtFecha.toLocaleDateString("es-EC", options);
    }

    isValidated_all(tam,tam2) {
      
        //console.log('dentro del isvalidated_all del padre') 
        //console.log(tam)
        //console.log(tam2)
        if (tam >= this.state.materias.length && tam2 >= this.state.actividades.length) {
            //btnchecknext.disabled = false;
            this.setState({
                valida_next:true
            }) 
            
        }
    }

    toggle = () => {
        this.setState({ abierto: !this.state.abierto });
    }

    renderTotal() {

        const totalmaterias = this.props.cargaMat ? this.props.cargaMat.map(horastot => horastot.totalHoras).reduce((acc2, item2) => (Number(acc2) + Number(item2)), 0) : 0;
        const totalactividades = this.props.cargaAct ? this.props.cargaAct.map(horastot2 => horastot2.totalHoras).reduce((acc2, item2) => (Number(acc2) + Number(item2)), 0) : 0;
        const talambitout = totalactividades + totalmaterias;
        const talambito = this.formatter(talambitout);

        return (
            <div className="inline-grid  grid-cols-1 bg-total">
                <div className="px-1">Total de Ámbito de Docencia Grado: {talambito} horas</div>
            </div>
            )
    }


    setconteo_final(tam) {
        //console.log('setconteo final en docencia de grado')
        //console.log(tam)
        this.props.setconteo_final(tam,'R')
    }

    setfila(tam) {
        this.setState({
            fila: tam
        })
        //console.log('setfila en docencia de grado')
        //console.log(tam)
        this.isValidated_all(this.state.fila_mat,tam)
    }

    render() {
       

        //let contents = this.renderActividadesTable(this.state.actividades);
        let contents_mat = this.renderMateriasTable(this.state.materias);
        let total = this.renderTotal()

        return (
            <div>
                <Resumen_Observaciones solicitudes={this.state.solicitudes_act} anio={this.props.anio} tipoactividad='R' /> {/*updatestate={this.updatestate} />*/}
                <Nueva_actividad actividades_combo={this.state.actividades_combo} anio={this.props.anio} abierto={this.state.abierto} toggle={this.toggle} tipoactividad='A|R' updatestate={this.updatestate} terminoPeriodo={this.props.terminoPeriodo} />
                {contents_mat}
                <Tabla_Actividades actividades={this.state.actividades} anio={this.props.anio} fila_mat={this.state.fila_mat} materias={this.state.materias}
                    valida_next={this.state.valida_next} tipoactividad='R' updatestate={this.updatestate} fila={this.state.fila} setfila={this.setfila} setconteo_final={this.setconteo_final} setSolicitudes={this.props.setSolicitudes}
                    toggle={this.toggle} terminoPeriodo={this.props.terminoPeriodo}
                />
                {total}

            </div>
        );
    }

    async populateActividadesData(idpersona, anio) { 
        const respuesta = this.props.cargaAct;
        const data = respuesta.filter(x => x.nivelEstudio === 'R');
        var selected = [];
        var actividades = [];
        if (data) {
            data.map(act => { selected.push({ idactividad: act.idactividad, validada: "", estado_actividad: "" }) })
            //data.map(act => { actividades.push({ ambito: 'AR', idactividad: act.idactividad, totalhoras: act.totalhoras, anio: act.anio, termino: act.termino1 + '|' + act.termino2 + '|' + act.termino3 }) })
            data.map(act => { actividades.push({ ambito: 'A|R', idactividad: act.idActividad }) })
            var actividades2 = [];
            data.map(act => {
                actividades2.push({
                    tipo: 'A|R', idactividad: act.idActividad, anio: act.anio,
                    descripcion: act.descripcion, periodo: act.termino1 + '|' + act.termino2 + '|' + act.termino3, accion: '', observacion: '',
                    totalhoras: act.totalHoras, validado: 1, idUnico: act.idUnico
                })
            })
            this.props.updateCarga(actividades, actividades2, 'A|R');
        }

        this.setState({ actividad_elegida: selected, actividades: data, loading: false });

    }

    async populateMateriasData(idpersona, anio) {
        //const response = await fetch(API_URL + 'TblMaterias/' + idpersona + '/' + anio);
        //const response = this.props.cargaMat;
        const respuesta = this.props.cargaMat;//await response.json();
        const data = respuesta;
        this.setState({ materias: data, loading2: false });
        var selected = [];
        var actividades = [];
        if (data) {
            data.map(act => { selected.push({ idcurso: act.idCurso, validada: "", estado_actividad: "" }) })
            //data.map(act => { actividades.push({ ambito: 'MR', idactividad: act.idcurso, totalhoras: act.totalhoras, anio: act.anio, termino: act.termino}) })
            data.map(act => { actividades.push({ ambito: 'M|R', idactividad: act.idCurso }) })
            var actividades2 = [];
            data.map(act2 => {
                actividades2.push({
                    tipo: 'M|R', idactividad: act2.idCurso, anio: act2.anio, descripcion: act2.nomMateria,
                    periodo: act2.termino, accion: '', observacion: '', totalhoras: act2.totalHoras, validado: 1
                })
            })
            this.props.updateCarga(actividades, actividades2, 'M|R');
        }

        this.setState({ materia_elegida: selected, materias: data, loading: false }, () => {

            // AGREGAR MATERIAS VALIDADAS EN 1S
            //console.log("materias grado: ", this.state.materias);
            if (this.props.terminoPeriodo === "2S") {

                var checkSin = document.getElementById("Materias_mg").getElementsByClassName('form-check-input');

                this.state.materias.map((item, index) => {
                    if (item.term.trim() === "1S" || item.term.trim() === "0S" || item.term.trim() === "3S") {
                        //console.log("termino != 2S: ", item);

                        //var checkNeeded = checkSin["ch1_" + item.idCurso];
                        //checkNeeded.checked = true;

                        this.state.fila_mat.push({
                            idactividad: item.idCurso,
                            validacion: 'si'
                        });
                    }
                });
                this.props.setconteo_final_mat(this.state.fila_mat, 'R');
            }
        });
    }

    async populateActividadesCombo(idpersona, anio) {
        const response = await fetch(API_URL + 'TblActividades/' + anio + '/R/token');
        const respuesta = await response.json();
        const data = respuesta;
        this.setState({ actividades_combo: data, loading: false });
    }


}
